export class DisconnectSourceAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "SourceAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectSourceAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
